<template>
  <section id="operations" class="o-section c-operations" v-my-section-class>
    <div class="o-background" v-if="device !== 0">
      <div class="o-background__inner">
        <svg ref="svg" :viewbox="'0 0 ' + viewport.width + ' ' + viewport.height " :width="viewport.width" :height="viewport.height"></svg>
      </div>
    </div>
    <div class="o-section__container" v-if="operations.length !== 0">
      <h2 class="o-section__title">Our operations</h2>

      <my-tabs class="o-tabs--wrapped" :class="{'o-tabs--no-bg': tabIndex === 0}" @tab-changed="tabChanged">

        <!-- TAB ONE =================== -->
        <my-tab class="c-operations__tab c-operations__tab--0" :title="operations[0].title">

          <!-- Content -->
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">{{ operations[0].title2 }}</h3>
            </div>
            <div class="o-panel__body" v-html="operations[0].body"></div>
            <div class="o-panel__footer" v-if="device !== 0">
              <div class="o-link__btn-group">
                <my-download-button :section="'operations'"></my-download-button>
                <my-video-button :video-code="'MuKPB2LH8r4'"></my-video-button>
              </div>
            </div>
          </my-tab-inner>

          <!-- <svg v-if="device === 0" ref="svg2" :viewbox="'0 0 ' + viewport.width + ' ' + viewport.height " :width="viewport.width" :height="viewport.height"></svg> -->

          <!-- <div class="c-operations__location"> -->
            <!-- Location buttons -->
          <transition name="quick-fade">
            <ul class="c-operations__btn-group" v-if="!section || device === 0">
              <li class="c-operations__btn o-link--throb" :class="['c-operations__btn--' + index]" @click="showDetail(index)" v-for="(item, index) in locations">
                <span class="o-link--throb__icon"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></span>
                <span class="u-hide o-link--throb__text">{{ item.title }}</span>
              </li>
            </ul>
          </transition>

          <!-- Location detail -->
          <transition name="quick-fade">
            <div class="c-operations__detail" v-if="section" @click="showDetail(false)">
              <div class="c-mobland c-operations__detail__inner"  :class="['c-operations__detail__inner--' + activeId]" @click.stop>
                <div class="o-section__container c-mobland__text">
                  <div class="c-mobland__text__header">
                    <h3 class="c-mobland__title">{{ section.title }}</h3>
                    <div class="c-mobland__text__header__controls">
                      <button class="c-mobland__button--desk-back" @click="showDetail(false)"><svg class="icon icon-cross"><use xlink:href="#icon-cross"></use></svg><span class="u-hide">Back</span></button>
                    </div>
                  </div>
                  <p><strong>{{ section.subtitle }}</strong></p>
                  <div class="c-mobland__body" v-html="section.body"></div>
                </div>
              </div>
            </div>
          </transition>
          <!-- </div> -->

          <div class="o-section__container"  v-if="device === 0">
            <div class="o-link__btn-group">
              <my-download-button></my-download-button>
              <my-video-button :video-code="'MuKPB2LH8r4'"></my-video-button>
            </div>
          </div>

        </my-tab>

        <!-- TAB TWO =================== -->
        <my-tab class="c-operations__tab c-operations__tab--1" :title="operations[1].title">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-tab__title o-panel__title">{{ operations[1].title2 }}</h3>
            </div>
            <div class="o-panel__body" v-html="operations[1].body"></div>
          </my-tab-inner>
        </my-tab>

        <!-- TAB THREE =================== -->
        <my-tab class="c-operations__tab c-operations__tab--2" :title="operations[2].title">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-tab__title o-panel__title">{{ operations[2].title2 }}</h3>
            </div>
            <div class="o-panel__body">
              <div v-html="operations[2].body"></div>
              <div class="c-operations__kpis" v-if="operations[2].kpis.length !== 0">
                <div class="o-kpi o-kpi--icon" v-for="(kpi, index) in operations[2].kpis">
                  <h4 class="o-kpi__figure">
                    <span class="o-kpi__icon">
                      <svg class="icon icon-down-arrow-large" :class="['icon-' + kpi.slug]"><use :xlink:href="'#icon-' + kpi.slug"></use></svg>
                      <!-- <component :is="'icon-' + kpi.slug"></component> -->
                    </span>
                    <span v-html="kpi.title"></span>
                  </h4>
                  <p class="o-kpi__caption" v-html="kpi.body"></p>
                </div>
              </div>
            </div>

          </my-tab-inner>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import { select } from 'd3-selection'
import { xml } from 'd3-request'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import MyDownloadButton from '@/components/standard/my-download-button'
import MyVideoButton from '@/components/standard/my-video-button'
import { MySectionClass } from '@/directives/my-section-class.js'
import mixins from '@/mixins'
// import { IconCross, IconPlus, IconCable, IconNetwork, IconSun, IconPeople, IconPylon } from '@/components/standard/my-icons'

export default {
  name: 'my-operations',
  components: {
    MyTabs,
    MyTab,
    MyTabInner,
    MyDownloadButton,
    MyVideoButton
    // IconCross,
    // IconPlus,
    // IconCable,
    // IconNetwork,
    // IconSun,
    // IconPeople,
    // IconPylon
  },
  directives: {
    MySectionClass
  },
  mixins: [mixins],
  data () {
    return {
      svg: null,
      section: null
    }
  },
  computed: {
    operations () {
      return this.$store.state.content['operations'] || []
    },
    locations () {
      return this.$store.state.content['locations'] || []
    },
    viewport () {
      return this.$store.state.viewport
    },
    mapFile () {
      return require('@/assets/svg/uk-map.svg')
    },
    activeId () {
      return this.locations.indexOf(this.section)
    },
    device () {
      return this.$store.state.device
    }
  },
  methods: {
    showDetail (id) {
      this.section = (typeof id === 'number' && id < this.locations.length) ? this.locations[id] : null
    },
    tabChanged (val) {
      this.showDetail(false)
      this.setTabIndex(val)
    },
    renderSVG (svg) {
      this.$nextTick(() => {
        this.svg = select(this.$refs.svg)
        if (this.svg.node() === null) return
        xml(this.mapFile).mimeType('image/svg+xml').get((error, xml) => {
          if (error) throw error
          let orange = xml.documentElement.getElementById('uk-background')
          let turq = xml.documentElement.getElementById('uk-turq')
          let purple = xml.documentElement.getElementById('uk-purple')
          let background = xml.documentElement.getElementById('uk-orange')
          this.svg.node().append(orange)
          this.svg.node().append(turq)
          this.svg.node().append(purple)
          this.svg.node().append(background)
        })
      })
    }
  },
  mounted () {
    this.renderSVG()
  },
  watch: {
    device (val) {
      this.renderSVG()
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyOperations.vue?1eab5064